import cshtml from "refractor/cshtml";
export default cshtml;